import {
  getPagedAdminGroups,
  deleteAdminGroup,
  duplicateAdminGroup,
  updateOrCreateAdminGroup,
  getOneAdminGroup,
} from '../services/AdminGroupApiHelper';
import {
  APIStatus,
  StatusTag,
  LanguageTransLation,
  CheckStatus,
  SavedStatus,
} from '../config/CustomEnums';
import {
  createAction,
  convertNumberToCursor,
  convertCursorToNumber,
  delay,
  convertPKToId,
  getObjectFromSessionStorage,
  saveToSessionStorage,
  removeFromSessionStorage,
} from '../utils';
import { apiWithResponseHandle, loading } from './LoadingUtil';
import { AdminGroupErrorHandleFields } from '../containers/admin/adminGroups/AdminGroupErrorHandleFields';

const adminGroupSessionKey = 'tempAdminGroup';

const parseAdminGroup = (item) => {
  return {
    ...item,
    ownedPermissions: item?.permissions?.edges.map((item) => item.node) || [],
    permissionsString: item?.permissions?.edges
      .map((item) => item.node.name)
      .join(', '),
  };
};

const parseAdminGroupList = (data) => {
  return data.map((item) => parseAdminGroup(item.node));
};

const getInitialState = () => ({
  oneAdminGroup: {},
  listDisplayFields: [
    { displayName: 'ID', fieldName: 'pk' },
    { displayName: 'Name', fieldName: 'name', orderField: 'name' },
    { displayName: 'Permission', fieldName: 'permissionsString' },
  ],
  adminGroupList: [],
  allList: [],
  totalCount: 0,
  pageInfo: {
    startCursor: '',
    endCursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
  currentPage: 0,
  totalPage: 0,
  checkedList: [],
  checked: CheckStatus.initOrNotChecked,
  errorFields: {},
  saved: SavedStatus.init,
  formChanged: false,
});

export default {
  namespace: 'adminGroup',
  state: getInitialState(),
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    loadDataFromSessionAndSession(state, { payload }) {
      const tempAdminGroup = getObjectFromSessionStorage(adminGroupSessionKey);
      const serverAdminGroup = payload.data ? payload.data : {};

      const oneAdminGroup = { ...serverAdminGroup, ...tempAdminGroup };
      // if (payload?.isDuplicate) {
      //   delete oneAdminGroup.pk;
      //   delete oneAdminGroup.id;
      // }
      // saveToSessionStorage(adminGroupSessionKey, oneAdminGroup);

      return {
        ...state,
        oneAdminGroup,
      };
    },

    changeVals(state, { payload }) {
      let tempAdminGroup = getObjectFromSessionStorage(adminGroupSessionKey);

      let data = {};
      if (payload.vals) {
        data = payload.vals;
      }

      tempAdminGroup = { ...tempAdminGroup, ...data };
      saveToSessionStorage(adminGroupSessionKey, tempAdminGroup);

      return {
        ...state,
        formChanged: true,
      };
    },

    checkValsValid(state, { payload }) {
      let tempAdminGroup = payload
        ? payload
        : {
            ...state.oneAdminGroup,
            ...getObjectFromSessionStorage(adminGroupSessionKey),
          };

      let errorFields = { fields: [], messages: [] };
      let checked = CheckStatus.initOrNotChecked;

      Object.keys(AdminGroupErrorHandleFields).map((field) => {
        if (!tempAdminGroup[field]) {
          errorFields.fields.push(field);
          errorFields.messages.push({ field, errorType: 'required' });
        }
      });

      if (errorFields.fields.length > 0) {
        checked = CheckStatus.checkedWithFail;
      } else {
        checked = CheckStatus.checkedWithSuccess;
      }
      console.log('@@219: ', errorFields);
      return {
        ...state,
        checked,
        errorFields,
      };
    },

    clearData(state, { payload }) {
      return { ...state, ...getInitialState() };
    },

    assembleAdminGroupList(state, { payload }) {
      return {
        ...state,
        allList:  payload.isSelectorLoad && payload.page > 1
          ? [...state.allList, ...payload.adminGroupList]
          : payload.adminGroupList,
        adminGroupList: payload.adminGroupList,
        pageInfo: payload.pageInfo,
        currentLastCursor: payload.currentLastCursor,
        totalCount: payload.totalCount,
        totalPage: payload.totalPage,
      }
    },
  },
  effects: {
    getPagedAdminGroups: [
      function* ({ payload }, { call, put }) {
        const page = payload.page;
        const pageCursor = payload.page
          ? convertNumberToCursor((page - 1) * 20 - 1)
          : '';
        const serviceArgs = [
          getPagedAdminGroups,
          pageCursor,
          payload.reverse,
          payload.search,
          payload.moreSearch,
        ];
        function* onSuccess(data) {
          console.log('@@115: ', data);
          const pageInfo = data?.administratorGroups?.pageInfo;

          const currentLastCursor = pageInfo?.endCursor;
          const totalCount = data?.administratorGroups?.totalCount;

          yield put({
            type: 'assembleAdminGroupList',
            payload: {
              ...payload,
              adminGroupList: parseAdminGroupList(
                data?.administratorGroups?.edges,
              ),
              pageInfo: {
                startCursor: convertCursorToNumber(pageInfo?.startCursor) + 1,
                endCursor: convertCursorToNumber(pageInfo?.endCursor) + 1,
              },
              currentLastCursor,
              totalCount,
              totalPage: Math.ceil(totalCount / 20),
            },
          });
        }

        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    delete: [
      function* ({ payload }, { all, put, select }) {
        const { checkedList } = yield select((state) => ({
          checkedList: state.adminGroup.checkedList,
        }));

        let pks = [];
        checkedList.forEach((item) => {
          pks.push(item.pk);
        });

        const serviceArgs = [deleteAdminGroup, pks];
        const afterAction = payload.afterAction || (() => {});
        console.log('@@231: ', pks);
        function* onSuccess(data) {
          console.log('@@115: ', data);

          yield all([
            put({
              type: 'updateState',
              payload: {
                checkedList: [],
                formChanged: false,
              },
            }),
          ]);
          yield delay(1000);
          afterAction();
        }
        function* onFailed(data) {
          console.log('@@122: ', data);

          yield put({
            type: 'updateState',
            payload: {
              checkedList: [],
            },
          });
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess, onFailed);
      },
      { type: 'takeLatest' },
    ],
    duplicate: [
      function* ({ payload }, { all, put, select }) {
        const copyAdminGroup = payload.data;
        console.log('@@324: ', copyAdminGroup);
        const data = {
          name: `Copy of ${copyAdminGroup.name}`,
          permissions: copyAdminGroup.permissions.edges.map(
            (item) => item.node.pk,
          ),
        };

        const serviceArgs = [updateOrCreateAdminGroup, data];
        const afterAction = payload.afterAction || (() => {});

        function* onSuccess(data) {
          afterAction();
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getOneAdminGroup: [
      function* ({ payload }, { all, put, select }) {
        const serviceArgs = [
          getOneAdminGroup,
          convertPKToId('AdministratorGroupNode', payload.id),
        ];

        function* onSuccess(data) {
          yield all([
            put({
              type: 'loadDataFromSessionAndSession',
              payload: {
                data: parseAdminGroup(data?.administratorGroup),
              },
            }),
          ]);
        }

        yield apiWithResponseHandle(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    updateOrCreate: [
      function* ({ payload }, { all, put, select }) {
        const adminGroup = yield select(
          (state) => state.adminGroup.oneAdminGroup,
        );

        const tempAdminGroup = payload.data
          ? payload.data
          : {
              ...adminGroup,
              ...getObjectFromSessionStorage(adminGroupSessionKey),
            };
        console.log('@@371: ', tempAdminGroup, payload);
        let data = {
          name: tempAdminGroup.name,
          permissions: tempAdminGroup.permissions.map((item) => item.pk),
        };

        if (tempAdminGroup.pk) {
          data.id = tempAdminGroup.pk;
        }
        const serviceArgs = [updateOrCreateAdminGroup, data];

        function* onSuccess(data) {
          yield put({
            type: 'updateState',
            payload: {
              formChanged: false,
              saved: SavedStatus.savedWithSuccess,
            },
          });
          removeFromSessionStorage(adminGroupSessionKey);
        }

        function* onFailed(data) {
          console.log('@@122: ', data);
          yield put({
            type: 'updateState',
            payload: {
              saved: SavedStatus.savedWithFail,
            },
          });
        }

        function* onArgumentsError(data) {
          console.log('adminGroup onArgumentsError: ', data);
          yield put({
            type: 'updateState',
            payload: {
              saved: SavedStatus.savedWithFail,
            },
          });
        }

        yield loading(serviceArgs, onSuccess, onFailed, onArgumentsError);
      },
      { type: 'takeLatest' },
    ],
  },
};
